function initWeddingShop(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const settings = JSON.parse(root.querySelector('[data-wedding-settings]').textContent);
  const form = root.querySelector('.sw-buy-form');
  const variant = form.querySelector('[data-variant]');
  const scent = form.querySelector('[data-scent]');
  const quantity = form.querySelector('[data-quantity]');
  const mix = form.querySelector('[data-mix]');
  const ribbon = form.querySelector('[data-box-ribbon]');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: settings.currency || 'GBP' }).format(value / 100);
  const update = () => {
    const selected = variant.selectedOptions[0];
    const empty = selected.dataset.empty === 'true';
    const count = Number(quantity.value) || 0;
    const price = Number(selected.dataset.price);
    const emptyOption = scent.querySelector('[value="Not needed - empty"]');
    if (empty) scent.value = 'Not needed - empty';
    else if (scent.value === 'Not needed - empty') scent.value = '';
    for (const option of scent.options) {
      if (option.value) option.disabled = empty ? option !== emptyOption : option === emptyOption;
    }
    if (ribbon) {
      const boxed = selected.dataset.box === 'true';
      ribbon.disabled = !boxed;
      ribbon.required = boxed;
      ribbon.hidden = !boxed;
      form.querySelector(`label[for="${ribbon.id}"]`).hidden = !boxed;
    }
    root.querySelector('[data-price]').textContent = money(price);
    root.querySelector('[data-total]').textContent = money(price * count);
    root.querySelector('[data-quantity-total]').textContent = settings.pack > 1 ? `${count * settings.pack} ${settings.quantityTotal}` : '';
    const scentNote = scent.selectedOptions[0]?.dataset.notes || '';
    root.querySelector('[data-scent-note]').textContent = empty ? settings.empty : scentNote;
    if (mix) {
      const mixed = scent.value === 'Mixed fragrances' && !empty;
      mix.hidden = !mixed;
      mix.disabled = !mixed;
      const total = Array.from(mix.querySelectorAll('[data-mix-count]')).reduce((sum,input) => sum + Number(input.value || 0), 0);
      scent.setCustomValidity(mixed && total !== count * settings.pack ? settings.mixError : '');
    }
  };
  form.addEventListener('input', update);
  form.addEventListener('change', update);
  form.addEventListener('submit', event => {
    update();
    if (!form.reportValidity()) event.preventDefault();
  });
  const slides = Array.from(root.querySelectorAll('[data-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
  function showSlide(index) {
    slides.forEach(slide => { slide.hidden = slide.dataset.slide !== index; });
    thumbs.forEach(thumb => thumb.setAttribute('aria-current', thumb.dataset.thumb === index ? 'true' : 'false'));
  }
  thumbs.forEach(thumb => thumb.addEventListener('click', event => { event.preventDefault(); showSlide(thumb.dataset.thumb); }));
  if (slides.length) showSlide(slides[0].dataset.slide);
  update();
}
document.querySelectorAll('[data-wedding-shop]').forEach(initWeddingShop);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wedding-shop]').forEach(initWeddingShop));
